import { useQuery, type QueryFunctionContext } from "@tanstack/react-query";
import { configuration } from "src/configuration";
import type { FormSubmissionsReportRowDto } from "src/http";
import { FetchError, queryKeys, UrlUtilities, useAccessToken, type QueryParams } from "src/http";

const useGetFormSubmissionsReport = (queryParams?: QueryParams) => {
  const { getAccessToken } = useAccessToken();

  async function getFormSubmissionsReportRequest({
    queryKey,
  }: QueryFunctionContext<
    ReturnType<typeof queryKeys.formSubmissions.getFormSubmissionsReportWithQueryParams>
  >): Promise<FormSubmissionsReportRowDto[]> {
    const accessToken = await getAccessToken();
    const [{ queryParams }] = queryKey;

    const url = new URL(`${configuration.apiRootUrl}/form-submissions/report`);
    UrlUtilities.appendQueryParams(url, queryParams);

    const response = await fetch(url.href, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new FetchError(response);
    }

    return response.json();
  }

  return useQuery({
    queryKey: queryKeys.formSubmissions.getFormSubmissionsReportWithQueryParams(queryParams),
    queryFn: getFormSubmissionsReportRequest,
  });
};

export { useGetFormSubmissionsReport };
